import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customer:{},
  error: null,
  cancel: false,
  loading:false,
};

const CustomerSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setCustomers: (state, action) => {
      state.customer = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setCustomers, setLoading, setError } = CustomerSlice.actions;

export default CustomerSlice.reducer;
